// Cálculos compartidos de suscripción SaaS (usados en /pagos y en Super
// Administrador → Clientes). Mantener una sola fuente de verdad.
import { PLANES, FRECUENCIAS_PAGO } from "@/pages/Landing";

/**
 * Calcula la información de suscripción para una empresa.
 * @param {object} empresa  Documento de empresa (con `plan`, `frecuencia_pago`, `created_at`).
 * @param {number} nColabs  Cantidad de colaboradores activos.
 * @returns {{ plan, frecuencia, nColabs, total, proximoPagoISO, diasRest }}
 */
export function computeSuscripcion(empresa, nColabs = 0) {
  if (!empresa) return null;
  const plan = PLANES.find(p => p.key === (empresa.plan || "oro")) || PLANES[1];
  const frecuencia = FRECUENCIAS_PAGO.find(f => f.key === (empresa.frecuencia_pago || "mensual")) || FRECUENCIAS_PAGO[0];

  // Monto del ciclo = (base + porColab × colabs) × meses × (1 − descuento)
  const brutoCiclo = (plan.base + plan.porColab * nColabs) * frecuencia.meses;
  const total = Math.round(brutoCiclo * (1 - frecuencia.descuento));

  // Próximo pago: si el backend ya lo calculó, se usa ese valor.
  // Si no, se aproxima como fecha_registro (empresa.created_at) + 25 días.
  let proximoPago;
  if (empresa.proximo_pago_at) {
    proximoPago = new Date(empresa.proximo_pago_at);
  } else {
    const base = empresa.created_at ? new Date(empresa.created_at) : new Date();
    proximoPago = new Date(base.getTime() + 25 * 24 * 60 * 60 * 1000);
  }
  const diasRest = Math.ceil((proximoPago - new Date()) / (1000 * 60 * 60 * 24));

  // Info de capacidad del plan
  const PLAN_LIMITS = { plata: 10, oro: 50, platino: 100, diamante: 250, master: 999999 };
  const limit = PLAN_LIMITS[plan.key] ?? 999999;
  const cerca = limit !== 999999 && nColabs >= Math.floor(limit * 0.9);
  const excedido = limit !== 999999 && nColabs > limit;

  return {
    plan, frecuencia, nColabs, total,
    proximoPagoISO: proximoPago.toISOString().slice(0, 10),
    diasRest, limite: limit, cerca, excedido,
  };
}
